/** The outline colour of the mark. */
const INK = '#1B2A4A';

export type LogoMarkProps = {
    size?: number;
};

/** The KataQuiz robot head, the mark of the logo and the favicon; decorative, so hidden from screen readers. */
export function LogoMark({ size = 40 }: LogoMarkProps) {
    return (
        <svg width={ size } height={ size } viewBox="0 0 48 48" aria-hidden="true" style={ { flexShrink: 0, display: 'block' } }>
            <line x1="24" y1="3.5" x2="24" y2="10" stroke={ INK } strokeWidth="2.6" strokeLinecap="round"/>
            <circle cx="24" cy="4.5" r="3.8" fill="#FF6B4A" stroke={ INK } strokeWidth="2"/>
            <rect x="2.5" y="19" width="6" height="12" rx="2.5" fill="#FFC940" stroke={ INK } strokeWidth="2"/>
            <rect x="39.5" y="19" width="6" height="12" rx="2.5" fill="#FFC940" stroke={ INK } strokeWidth="2"/>
            <rect x="7" y="10" width="34" height="31" rx="10" fill="#3D7BEA" stroke={ INK } strokeWidth="3"/>
            <circle cx="17.5" cy="23" r="5.4" fill="#FFFFFF" stroke={ INK } strokeWidth="2"/>
            <circle cx="30.5" cy="23" r="5.4" fill="#FFFFFF" stroke={ INK } strokeWidth="2"/>
            <circle cx="19" cy="23" r="2.4" fill={ INK }/>
            <circle cx="32" cy="23" r="2.4" fill={ INK }/>
            <path d="M18.5 32.5 q5.5 4.5 11 0" stroke={ INK } strokeWidth="2.4" fill="none" strokeLinecap="round"/>
        </svg>
    );
}
